import { useEffect } from 'react';
import type {
  HydrogenOperatorBookingOverviewPaginatedData,
  HydrogenOperatorBookingOverviewRequestParams,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: HydrogenOperatorBookingOverviewRequestParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: HydrogenOperatorBookingOverviewRequestParams;
} & UrlTemplate;

export function useHydrogenOperatorBookingOverview({
  url,
  params,
}: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<HydrogenOperatorBookingOverviewPaginatedData>({
        ...baseConfig,
        url,
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  return request;
}

export type HydrogenOperatorBookingOverviewRequest = ReturnType<
  typeof useHydrogenOperatorBookingOverview
>;
